module.exports = __webpack_public_path__ + "img/distanceWedge5.12aa40b3.png";